import * as $ from 'jquery';
import 'jquery-colorbox';
import tabs from './Tabs/Tabs';

const whereToBuy = () => {
	const triggerLightbox = () => {
		const $elem = $('.whereToBuyButton--lightboxTrigger');
		if ($elem.length === 0) {
			return;
		}

		$elem.colorbox({
			className: 'whereToBuyLightboxWrap',
			transition: 'elastic',
			initialWidth: '200',
			initialHeight: '200',
			width: '90%',
			maxWidth: '1070px',
			height: '90%',
			fixed: true,
			inline: true,
			href: '#whereToBuyLightbox',
			close: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" height="44" fill="#fff"><path d="M13.458 15.336l1.485-1.485 15.344 15.344-1.485 1.485z"> </path><path d="M12.961 29.2l15.344-15.343 1.485 1.485-15.344 15.344z"> </path></svg><span>Close</span>',
			onOpen: () => {
				document.querySelector('html').classList.add('lockScroll');
			},
			onClosed: () => {
				document.querySelector('html').classList.remove('lockScroll');
			}
		});
	};
	$(window).on('load', function () { // Needed since the referenced elements don't exist on page load and are created in <script type="text/template">
		triggerLightbox();
	});

	// 'Buy With Prime' needs to be updated when selected variation changes
	// console.log('bwp?', (window as any).bwp);
	const updateIfBwpEnabled = (enabled: boolean, variationSelected: boolean) => {
		const $productDiv = $('.product');
		$productDiv.toggleClass('product--bwpEnabled', enabled);
		$productDiv.toggleClass('product--variationSelected', variationSelected);

		triggerLightbox();
		tabs();
	};

	const bwpEnabledOnBase = (window as any).bwp !== undefined;
	const $variationWrap = $('.single_variation_wrap');
	const isSimpleProduct = $variationWrap.length == 0;

	updateIfBwpEnabled(bwpEnabledOnBase, isSimpleProduct)

	$variationWrap.on('hide_variation', function() {
		updateIfBwpEnabled(bwpEnabledOnBase, false);
	});
	$variationWrap.on('show_variation', function( event, variation ) {
		// console.log('show_variation', variation);
		updateIfBwpEnabled(variation.tcc_enableBuyWithAmazon, true);
	});
	if (bwpEnabledOnBase) {
		// Only if buy with prime code was output for this product page
		const bwpFireUpdate = (bwpEnabled:boolean, sku:string) => {
			// console.log('buy with prime udpating', bwpEnabled, sku);
			if (bwpEnabled) {
				const quantity = 1;
				const variantSkus: any[] = [];
				(window as any).bwp.updateWidget(sku, quantity, variantSkus);
			}
		}
		$('.single_variation_wrap').on('show_variation', function( event, variation ) {
			// console.log('show_variation', variation);
			bwpFireUpdate(variation.tcc_enableBuyWithAmazon, variation.sku);
		});
	}
};

export default whereToBuy;